var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2834_63784",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2834_63784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "my_location"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2834_63784",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box_2",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2834_63784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "my_location_2",
    d: "M11.0008 22.9498V20.9498C8.91745 20.7165 7.12995 19.854 5.63828 18.3623C4.14661 16.8706 3.28411 15.0831 3.05078 12.9998H1.05078V10.9998H3.05078C3.28411 8.91647 4.14661 7.12897 5.63828 5.6373C7.12995 4.14564 8.91745 3.28314 11.0008 3.0498V1.0498H13.0008V3.0498C15.0841 3.28314 16.8716 4.14564 18.3633 5.6373C19.8549 7.12897 20.7174 8.91647 20.9508 10.9998H22.9508V12.9998H20.9508C20.7174 15.0831 19.8549 16.8706 18.3633 18.3623C16.8716 19.854 15.0841 20.7165 13.0008 20.9498V22.9498H11.0008ZM12.0008 18.9998C13.9341 18.9998 15.5841 18.3165 16.9508 16.9498C18.3174 15.5831 19.0008 13.9331 19.0008 11.9998C19.0008 10.0665 18.3174 8.41647 16.9508 7.0498C15.5841 5.68314 13.9341 4.9998 12.0008 4.9998C10.0674 4.9998 8.41745 5.68314 7.05078 7.0498C5.68411 8.41647 5.00078 10.0665 5.00078 11.9998C5.00078 13.9331 5.68411 15.5831 7.05078 16.9498C8.41745 18.3165 10.0674 18.9998 12.0008 18.9998ZM12.0008 15.9998C10.9008 15.9998 9.95912 15.6081 9.17578 14.8248C8.39245 14.0415 8.00078 13.0998 8.00078 11.9998C8.00078 10.8998 8.39245 9.95814 9.17578 9.1748C9.95912 8.39147 10.9008 7.9998 12.0008 7.9998C13.1008 7.9998 14.0424 8.39147 14.8258 9.1748C15.6091 9.95814 16.0008 10.8998 16.0008 11.9998C16.0008 13.0998 15.6091 14.0415 14.8258 14.8248C14.0424 15.6081 13.1008 15.9998 12.0008 15.9998ZM12.0008 13.9998C12.5508 13.9998 13.0216 13.804 13.4133 13.4123C13.8049 13.0206 14.0008 12.5498 14.0008 11.9998C14.0008 11.4498 13.8049 10.979 13.4133 10.5873C13.0216 10.1956 12.5508 9.9998 12.0008 9.9998C11.4508 9.9998 10.9799 10.1956 10.5883 10.5873C10.1966 10.979 10.0008 11.4498 10.0008 11.9998C10.0008 12.5498 10.1966 13.0206 10.5883 13.4123C10.9799 13.804 11.4508 13.9998 12.0008 13.9998Z",
    fill: "black"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/current_location.bca47aeec320697120e55d81e32b7909.svg";
export { ForwardRef as ReactComponent };